




































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
export default {
    name: 'company_jobs'

    watch:
        '$store.state.selected_company': (value)->
            @get_jobs()

    data: ()->
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        jobs: []

    computed:
        data_filtered: ()->
            self = @
            data = @jobs.filter (x) ->
            # Added Normalize('NFD') to remove all accents once user search
                !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        has_mutation_right: ()->
            return @has_access_right('jobs_edit')

        has_deletion_right: ()->
            return @has_access_right('jobs_delete')

        doc_url: ()->
            # console.log "DOCURL ", settings.document_url
            return settings.document_url

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @jobs.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
            # @jobs.sort (a,b)->
            #     modifier = 1
            #     if order == 'descending'
            #         modifier = -1
            #     if a[prop].toLowerCase() < b[prop].toLowerCase()
            #         return -1 * modifier
            #     if a[prop].toLowerCase() > b[prop].toLowerCase()
            #         return 1 * modifier
            #     return 0
            # console.log "JOBS SORT ", @jobs

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_jobs: ()->
            self = @
            @loading = true
            q.run('get_job_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_jobs: get_jobs: then", e.message)
                else
                    # console.log "RUN QUERY JOBS : ", resp.body.data.job_set
                    self.jobs = resp.body.data.job_set
                    self.loading = false
                    if self.jobs.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "company_jobs: get_jobs()")

        delete_job: (job_uid)->
            self = @
            h = this.$createElement
            @$confirm('', 'Confirmation', {
                message: h('p', null, [
                    h('span', null, "Êtes-vous sûr·e de vouloir supprimer ce métier, "),
                    h('span', { style: 'color: red; font-weight: bold;' }, 'ainsi que tous les éventuels contrats et recrutements liés à ce métier'),
                    h('span', null, " ?")
                  ]),
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "JOB EDITION DELETE"
                    m.run('delete_job', [job_uid])
                    .then (resp)->
                        # console.log "DELETE JOB", resp.body.data.job_deletion
                        if resp.body.data.job_deletion.ok
                            n.success()
                            self.get_jobs()
                        else
                            n.gql_error("company_jobs: delete_job: then", resp.body.data.job_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_jobs: delete_job()")
                .catch (cancel)->
                    return

        duplicate_job: (job_uid)->
            # console.log "DUPLICATE JOB"
            self = @
            m.run('duplicate_job', [[job_uid], true, @$store.getters.current_company.uid])
            .then (resp)->
                # console.log "DUPLICATE JOB", resp.body.data.job_duplication
                if resp.body.data.job_duplication.ok
                    n.success()
                    self.get_jobs()
                else
                    n.gql_error("company_jobs: duplicate_job: then", resp.body.data.job_duplication.message)
            .catch (resp)->
                n.catch_error(resp, "company_jobs: duplicate_job()")

    beforeMount: ()->
        @get_jobs()
}
